import { ACCESS_TOKEN_NAME, JSON_CONTENT_TYPE } from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiAddCloudLink = async (
  section: string,
  route: string,
  page: string,
  id: string,
  title: string
) => {
  const params: IApiParams = {
    url: `/admin/addCloudLinl.php?section=${section}&route=${route}&page=${page}&id=${id}&title=${title}&${secureToken()}`,
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'POST');
};
